module.exports = __webpack_public_path__ + "img/piq.38ce459a.jpg";